module.exports = __webpack_public_path__ + "img/register_2.6d80e513.jpg";